$(document).ready(function () {
  if ($(".product-add-to-cart-button").length) {
    $(".product-add-to-cart-button").on("click", function (evt) {
      const icon_cart = $(this).find('.icon-cart');
      const icon_loader = $(this).find('.icon-loader');
      icon_cart.hide();
      icon_loader.show();
      let formData = {
        'items': [{
          'id': $(this).data('variant-id'),
          'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          icon_cart.show();
          icon_loader.hide();
          document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem')); //dispatch event if cart mode is set to page
        })
        .catch((error) => {
          // console.error('Error:', error);
          icon_cart.show();
          icon_loader.hide();
        });
      evt.preventDefault();
      return false;
    })
  }

  if ($("#goTorelatedProducts").length) {
    $("#goTorelatedProducts").on('click', function () {
      $('html,body').animate({
        scrollTop: $('#productReccomendationsUl').offset().top
      },'slow');
    })
  }

  if ($("#emailMeWhenAvailable").length) {
    $("#emailMeWhenAvailable").on('click', function () {
        $('.bis-reset .bis-image').trigger('click');
    })
  }

  if ($(".zen").length) {
    document.querySelector('.zen').addEventListener('click', function () {
      zE.activate();
    });
  }
});

